module.exports = __webpack_public_path__ + "media/printed-materials/educators-06-college-qrg-dcaa6e53.jpg";